
    import __i18nConfig from '@next-translate-root/i18n.json'
    import __appWithI18n from 'next-translate/appWithI18n'
    import 'tailwindcss/tailwind.css';
import 'react-toastify/dist/ReactToastify.css';
import 'react-bezier-curve-editor/index.css';
import '@/styles/app.css';
import React from 'react';
import Head from 'next/head';
import { RecoilRoot } from 'recoil';
import type { AppProps } from 'next/app';
import { Client, Provider, cacheExchange, fetchExchange } from 'urql';
import debug from 'debug';
import { ErrorBoundary } from '@/components/generic';
const client = new Client({
    url: '/api/graphql',
    exchanges: [cacheExchange, fetchExchange],
});
if (typeof window !== "undefined") {
    Object.assign(window, { debug });
}
function App({ Component, pageProps }: AppProps) {
    return (<ErrorBoundary>
      <Head>
        <title>Figmotion</title>
      </Head>
      <RecoilRoot>
        <Provider value={client}>
          <Component {...pageProps}/>
        </Provider>
      </RecoilRoot>
    </ErrorBoundary>);
}

    export default __appWithI18n(App, {
      ...__i18nConfig,
      isLoader: true,
      skipInitialProps: true,
      loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../locales/' + l + '/' + n).then(m => m.default)),
    });
  